module.exports = __webpack_public_path__ + "static/media/Rain.3ebbe9bf.svg";